export const coupons = {
  "Odśwież cache promowanych kuponów": "Refresh promoted coupons cache",
  "Ilość użyć": "Amount of uses",
  "Główne informacje": "Main settings",
  "Nie jest możliwa edycja nazwy istniejącego już kuponu.": "It is not possible to change name of already existing coupon.",
  "Próg oznacza minimalną wartość koszyka od której zostanie użyty dana wartość efektu.": "Treshold means minimal cart value, from which given effect's value would be used.",
  "W przypadku zdefiniowania kilku progów użyta zostanie wartość efektu najbliższego progu mniejszego od wartości koszyka (np. dla progów 0,50,75zł i koszyka o wartości 65zł zostanie użyty próg od 50zł).": "In case of defining few thresholds, system would use effect's value of closest threshold that is lower than cart's value (e.g. for thresholds 0,50 and 75PLN and for cart of total value 65PLN, system would use threshold from 50PLN).",
  "Gdy próg wynosi 0, wtedy dana wartość efektu będzie aktywna dla ceny koszyka od 0 do najbliższego kolejnego progu.": "If threshold is equal to 0 then given threshold would be active for cart's with value from 0 to next threshold.",
  "Jednorazowy": "Disposable",
  "Kod można użyć tylko i wyłącznie jeden raz": "Coupon would be used only once",
  "Jeżeli kupon nie jest zaznaczony jako aktywny to nie będzie można go używać.": "If coupon is not set as active, it wouldn't be possible to use it.",
  "Promowany": "Promoted",
  "Jeżeli kupon jest zaznaczony jako promowany to będzie on wyświetlany na stronie, np na karcie produktu.": "If coupon is set as promoted then it will be displayed on store, e.g. on product page.",
  "Generuj wiele kuponów": "Generate many coupons",
  "Generuj": "Generate",
  "Kupony - edycja": "Coupons - edit",
  "Kupon w tej chwili nie działa": "Coupon is currently not active",
  'Pomimo, że status kuponu to "aktywny", kupon w tej chwili nie działa, ponieważ data ważności kuponu upłynęła lub jeszcze nie nadeszła.': 'Though coupon is set as "active", it is currently not possible to use it, because currently coupon\'s date rule is not passed.',
  "Tylko przecenione": "In sale",
  "Tylko nieprzecenione": "Not in sale",
  "Strona internetowa": "Store - website",
  "Aplikacja mobilna": "Mobile app",
  "Próg (minimalna wartość koszyka)": "Threshold (minimal cart value)",
  "Usuń ten próg": "Delete this threshold",
  "Dodaj nowy próg": "Add new threshold",
  "Data początkowa ważności kuponu nie może być większa od daty końcowej.": "Date 'valid since' could not be past 'valid until'.",
  "Ekstra produkty": "Extra products",
  "Metody dostawy": "Shipment methods",
  "Nieposiadający słowa kluczowego": "Without keyword",
  "Produkty przecenione": "Products on sale",
  "Cena produktu": "Product's price",
  "Usuń ten produkt": "Remove product",
  "Dodaj nowy produkt": "Add product",
  "Wyłącznie wybrane sposoby dotawy będą widoczne na checkout'ie.": "Only selected shipment methods would be displayed on order's checkout",
  "Kategoria": "Categories",
  "Minimalna wartość koszyka": "Minimal cart value",
  "Minimalny % przeceny": "Min sale %",
  "Maksymalny % przeceny": "Max sale %",
  "Typ aplikacji": "Application type",
  "Adres email": "Email address",
  "Promocja silnikowa": "Engine promotion",
  "X za X-1": "X for X-1",
  "X z obniżką": "X with discount",
  "Produkt za X": "Product for X",
  "Cross selling - ilościowa": "Cross selling - amount",
  "Cross selling - procentowa": "Cross selling - percent",
  "Cross selling - za X": "Cross selling - for X",
  "Łączenie z": "Combining with",
  "W tym kontekście przez 'promocję' rozumiemy nie tylko promocje silnikowe ale także kupony": "In this context, by word 'promotion' we mean not only engine promotions, but also coupons",
  "promocjami": "promotions",
  "Nie sprecyzowano reguł łączenia. Zostaną użyte globalne ustawienia sklepu.": "No combinations rules. Global store settings will be used.",
  "Dodaj nową regułę łączenia": "Add new combination rule",
  "Rodzaj promocji": "Promotion type",
  "Czy umożliwić łączenie z wybraną promocją": "Enable to combine with selected promotion",
  "Zaznaczając checkbox ustalasz, że promocja, którą wybierzesz, będzie się łączyła z kuponem.": "If you check this checkbox, selected promotion would be combinable with coupon.",
  "Ustawienie odznaczonego checkboxa oznacza, że wybrana promocja nie będzie się łączyć z tym kuponem (nawet jeśli inna reguła pozwala na łączenie kuponu ze wszystkimi promocjami)": "If you left this checkbox unchecked, selected promotion would not be combinable with coupon (even if other rule is allowing combination)",
  "Dodaj regułę": "Add rule",
  "Usuń regułę łączenia": "Delete rule",
  "Rodzaj powiązania": "Combination type",
  "Identyfikator promocji (globalna, jeśli brak)": "Promotion identifier (globally, if not set)",
  "Akcje": "Actions",
  "\"Globalnie\" oznacza, że ta reguła łączenia będzie działała ze wszystkimi promocjami (chyba, że zostaną sprecyzowane dodatkowe wykluczenia konkretnych promocji)": "\'Globally\' means that this combination rule would be working with all types of promotions (unless there will be specified additional excluding rules of specific promotions)",
  "Wystąpił błąd - Nie udało się usunąć wybranej reguły łączenia. Skontaktuj się z administratorem.": "An error occured - failed to delete this combination rule. Please, contact with administrator.",
  "Ta reguła będzie działać na wszystkie kupony.": "This combining rule will be working with all coupons",
  "Czy ta reguła ma dotyczyć wszystkich promocji silnikowych?": "Does this combining rule should work with all types of engine promotions?",
  "Identyfikator promocji silnikowej": "Engine promotion identifier",
  "Łączenie": "Combining",
  "Globalnie": "Globally",
  "Wykluczanie": "Excluding","Dodaj jeden kupon": "Add single coupon",
  "Dodaj wiele takich kuponów": "Generate multiple coupons",
  "Aby wygenerować wiele kuponów o podanych w formularzu atrybutach, musisz określić reguły generowania nazw kuponów.": "To generate many coupons (with properties provided in the form), you have to specify rules of names generation.",
  "Każdy kupon musi posiadać unikalną nazwę. Aby to osiągnąć, możesz połączyć tekst statyczny (np. NEWSLETTER) z tekstem losowym (np. kilkoma losowymi cyframi).": "Every coupon must have unique name. To achieve it, you can combine some static text (e.g. NEWSLETTER) with random characters (e.g. with few digits).",
  "Liczba kuponów": "Amount of coupons",
  "Liczba kuponów do wygenerowania": "Amount of coupons to generate",
  "Części składowe generowanych nazw": "Text parts of generated name",
  "Reguła nazwy": "Name rule",
  "Tekst statyczny": "Static text",
  "Tekst losowy": "Random text",
  "Tekst": "Text",
  "Tekst, który w całości znajdzie się w nazwie kuponu, np. NEWSLETTER.": "Entire text, that will be part of coupon's generated names.",
  "Przesuń wcześniej w kolejności": "Move backwards in order",
  "Przesuń dalej w kolejności": "Move further in order",
  "Zestawy znaków": "Character set",
  "Cyfry": "Digits",
  "Znaki, z których losować tekst": "Characters to randomly draw from",
  "Zestaw znaków, z których losowo zostanie wybrana dana ilość, np. 0123456789 albo abcdefghijklmnopqrstuwxyz": "Characters set, from which will be randomly drawed specified amount of characters, e.g. 0123456789 or abcdefghijklmnopqrstuwxyz",
  "Długość wylosowanego tekstu": "Length of randomly drawed text",
  "Ile znaków ma mieć tekst wylosowany z podanych wcześniej znaków.": "How long should be randomly drawed text from specified characters set.",
  "Duże litery": "Letters uppercase",
  "Duże litery i cyfry": "Letters uppercase and digits",
  "Własne": "Custom",
  "Poprawnie wygenerowano {{amount}} kuponów!": "Successfully generated {{amount}} coupons!",
  "Udało się!": "Success!",
  "Nazwy kuponów skopiowane do schowka": "Coupons names has been copied",
  "Kopiuj nazwy": "Copy names",
  "Wyeksportuj jako CSV": "Export as CSV",
};



// WEBPACK FOOTER //
// ./locales/en_US/coupons.js